import PropTypes from 'prop-types'
import { Button } from '@mui/material'
import useTranslations from '../../../i18n/useTranslations'
import useIsMobile from '../../../hooks/useIsMobile'
import ModalLayout from '../layout'

const LogoutModal = ({ onCancel, onConfirm }) => {
  const t = useTranslations()

  const isMobile = useIsMobile()

  return (
    <ModalLayout
      isOpen
      title={t('noun:sure-logout')}
      onClose={onCancel}
      actions={
        <>
          <Button
            type="button"
            size={isMobile ? 'medium' : 'small'}
            variant="outlined"
            onClick={onCancel}
          >
            {t('action:cancel')}
          </Button>
          <Button
            type="submit"
            size={isMobile ? 'medium' : 'small'}
            onClick={onConfirm}
          >
            {t('action:yes-logout')}
          </Button>
        </>
      }
    />
  )
}

LogoutModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default LogoutModal
